const NUMBER_RE = /-?\d+(?:\.\d+)?/;

export function parseNumericValue(body: string): number | undefined {
  const match = NUMBER_RE.exec(body);
  return match ? Number(match[0]) : undefined;
}
